// Ancestor lineage highlight (Story E)
//
// buildAncestorPaths(root) returns Map<nodeKey, Set<nodeKey>> — for each node,
// the set of all nodeKeys on the path from the root down to it (inclusive).
//
// applyHighlight / clearHighlight toggle CSS classes on tree-node + tree-link
// SVG elements based on a given pathSet.

export function buildAncestorPaths(root) {
  const paths = new Map()
  const visit = (node, ancestorKeys) => {
    const key = node.data.nodeKey
    const ownPath = new Set(ancestorKeys)
    ownPath.add(key)
    paths.set(key, ownPath)
    const nextAncestors = [...ancestorKeys, key]
    for (const child of (node.children || [])) visit(child, nextAncestors)
  }
  visit(root, [])
  if (root._orphanSubtrees) {
    for (const sub of root._orphanSubtrees) visit(sub, [])
  }
  return paths
}

export function applyHighlight(rootEl, pathSet) {
  const nodes = rootEl.querySelectorAll(".tree-node")
  for (const el of nodes) {
    const key = el.getAttribute("data-node-key")
    if (pathSet.has(key)) {
      el.classList.add("tree-node--on-path")
      el.classList.remove("tree-node--muted")
    } else {
      el.classList.add("tree-node--muted")
      el.classList.remove("tree-node--on-path")
    }
  }
  // TODO: extend to links once link elements expose their endpoint keys.
}

export function clearHighlight(rootEl) {
  const nodes = rootEl.querySelectorAll(".tree-node--on-path, .tree-node--muted")
  for (const el of nodes) {
    el.classList.remove("tree-node--on-path", "tree-node--muted")
  }
}
